import React from 'react'
import { Tag } from "antd" 
import { IoIosCheckmarkCircle, IoIosCloseCircle  } from "react-icons/io";


function TagActiveStatus({result = ""}) {
  let elementToRender;

  switch (result?.toLowerCase()) {
    case 'เปิดการใช้งาน':
      elementToRender = <Tag icon={<IoIosCheckmarkCircle />} color="#87d068" className='flex gap-2 justify-center items-center' > เปิดการใช้งาน </Tag>;
      break;
    case 'ปิดการใช้งาน':
      elementToRender = <Tag icon={<IoIosCloseCircle />} color="#cd201f" className='flex gap-2 justify-center items-center' > ปิดการใช้งาน </Tag>;
      break;
    default:
      elementToRender = <Tag  className='flex gap-2 justify-center items-center' > Not found </Tag>;
  }
  return <>{elementToRender}</>
}

export default TagActiveStatus